import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

// Define the script-related API endpoints
export const scriptApi = createApi({
  reducerPath: "scriptApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
  }),
  endpoints: (builder) => ({
    getScript: builder.query({
      query: ({ projectId }) => ({
        url: `project/${projectId}/script`,
        responseHandler: (response) => response.text(),
      }),
    }),
    updateScript: builder.mutation({
      query: ({ projectId, content }) => ({
        url: `project/${projectId}/script`,
        method: "POST",
        body: { content },
      }),
    }),
  }),
});

export const { useGetScriptQuery, useUpdateScriptMutation } = scriptApi;
export default scriptApi;
